import { useState } from "react";

import { FaEye, FaEyeSlash } from "react-icons/fa";

import api from "../../api";

export default function LoginForm({
  onLoginSuccess,
  setTab,
  error,
  setError,
}) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    setLoading(true);
    setError("");

    try {
      const response = await api.post("/api/custom/login/", {
        email,
        password,
      });

      const data = response.data;
      const userRole = data.role;

      if (userRole === "admin") {
        window.location.href = "/admin/";
      } else {
        onLoginSuccess(data);
      }
    } catch (err) {
      setError("Login failed: check your credentials.");
    }

    setLoading(false);
  };

  return (
    <>
      <form className="space-y-4" onSubmit={handleLogin}>

        <div className="grid grid-cols-2 gap-4">

          {/* EMAIL */}
          <div className="relative w-full">
            <input
              type="email"
              id="login-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder=" "
              className="
                peer
                w-full
                border
                border-[#D8CBB8]
                rounded-lg
                px-3
                pt-5
                pb-2
                bg-[#FFFDF8]
                text-[#2F241D]
                focus:outline-none
                focus:border-[#0F766E]
                focus:ring-1
                focus:ring-[#0F766E]
                transition
              "
              disabled={loading}
              required
            />

            <label
              htmlFor="login-email"
              className="
                absolute
                left-3
                top-3
                text-[#8A8172]
                text-base
                transition-all
                bg-[#FFFDF8]
                px-1

                peer-placeholder-shown:top-3
                peer-placeholder-shown:text-[#A39A8D]
                peer-placeholder-shown:text-base

                peer-focus:-top-2
                peer-focus:text-sm
                peer-focus:text-[#0F766E]

                peer-[&:not(:placeholder-shown)]:-top-2
                peer-[&:not(:placeholder-shown)]:text-sm
                peer-[&:not(:placeholder-shown)]:text-[#0F766E]

                cursor-text
              "
            >
              Email
            </label>
          </div>

          {/* PASSWORD */}
          <div className="relative w-full">
            <input
              type={showPassword ? "text" : "password"}
              id="login-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder=" "
              className="
                peer
                w-full
                border
                border-[#D8CBB8]
                rounded-lg
                px-3
                pt-5
                pb-2
                bg-[#FFFDF8]
                text-[#2F241D]
                focus:outline-none
                focus:border-[#0F766E]
                focus:ring-1
                focus:ring-[#0F766E]
                transition
              "
              disabled={loading}
              required
            />

            <label
              htmlFor="login-password"
              className="
                absolute
                left-3
                top-3
                text-[#8A8172]
                text-base
                transition-all
                bg-[#FFFDF8]
                px-1

                peer-placeholder-shown:top-3
                peer-placeholder-shown:text-[#A39A8D]
                peer-placeholder-shown:text-base

                peer-focus:-top-2
                peer-focus:text-sm
                peer-focus:text-[#0F766E]

                peer-[&:not(:placeholder-shown)]:-top-2
                peer-[&:not(:placeholder-shown)]:text-sm
                peer-[&:not(:placeholder-shown)]:text-[#0F766E]

                cursor-text
              "
            >
              Password
            </label>

            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="
                absolute
                right-3
                top-1/2
                transform
                -translate-y-1/2
                text-[#8A8172]
                hover:text-[#0F766E]
                transition
              "
              aria-label={
                showPassword
                  ? "Hide password"
                  : "Show password"
              }
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>

        {/* FORGOT PASSWORD */}
        <div className="mt-2 text-right">
          <button
            type="button"
            onClick={() => setTab("forgot")}
            className="
              text-sm
              font-medium
              text-[#0F766E]
              hover:text-[#0B5F59]
              hover:underline
              transition
            "
          >
            Forgot your password?
          </button>
        </div>

        {/* ERROR */}
        {error && (
          <p
            className="
              text-red-600
              text-center
              text-sm
              mt-2
              bg-red-50
              border
              border-red-100
              rounded-lg
              px-3
              py-2
            "
          >
            {error}
          </p>
        )}

        {/* SUBMIT BUTTON */}
        <button
          type="submit"
          disabled={loading}
          className={`
            w-80
            mx-auto
            block
            text-white
            py-3
            rounded-lg
            font-medium
            mt-4
            transition-all
            duration-200
            ${
              loading
                ? "bg-[#8A8172] cursor-not-allowed"
                : "bg-[#0F766E] hover:bg-[#0B5F59] hover:shadow-md"
            }
          `}
        >
          {loading ? (
            <span className="flex items-center justify-center gap-2">
              Logging in

              <span className="flex space-x-1">
                <span className="dot dot1"></span>
                <span className="dot dot2"></span>
                <span className="dot dot3"></span>
              </span>
            </span>
          ) : (
            "Log in"
          )}
        </button>
      </form>
    </>
  );
}